import { render, staticRenderFns } from "./VModalRemarkSendError.vue?vue&type=template&id=39fd7faa&"
import script from "./VModalRemarkSendError.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkSendError.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkSendError.vue?vue&type=style&index=0&id=39fd7faa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports